"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _VerticalMenu = _interopRequireDefault(require("./VerticalMenu.style"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _Icon = _interopRequireDefault(require("../../component/Icon"));

var _Pill = _interopRequireDefault(require("../../component/Pill"));

var useStyles = (0, _ThemeProvider.createUseStyles)(_VerticalMenu["default"]);

var Item = function Item(_ref) {
  var item = _ref.item,
      index = _ref.index,
      onClick = _ref.onClick,
      active = _ref.active;
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme
  });

  var handleClick = function handleClick(item) {
    return function () {
      if (!item.disabled) onClick(item);else return false;
    };
  };

  return /*#__PURE__*/React.createElement("section", {
    key: index,
    "data-test-id": "vertical-menu-section-".concat(index),
    onClick: handleClick(item),
    className: (0, _classnames["default"])(classes.Section, active && 'active', (0, _defineProperty2["default"])({}, classes.DisabledSection, item.disabled))
  }, item.disabled && /*#__PURE__*/React.createElement(_Pill["default"], {
    kind: "negative",
    "data-test-id": "negative-pill",
    className: classes.DisabledPill
  }, item.disabledPillText), item.tag && /*#__PURE__*/React.createElement("div", {
    className: classes.Tag
  }, item.tag), /*#__PURE__*/React.createElement("div", {
    className: "section-content"
  }, /*#__PURE__*/React.createElement("section", {
    className: "title"
  }, item.title), /*#__PURE__*/React.createElement("section", {
    className: "subtitle"
  }, item.subtitle)), /*#__PURE__*/React.createElement("div", {
    className: "icon-container"
  }, active && /*#__PURE__*/React.createElement(_Icon["default"], {
    glyph: "chevron-right"
  })));
};

var VerticalMenu = function VerticalMenu(props) {
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme
  });

  if ('items' in props) {
    var items = props.items,
        onClick = props.onClick,
        activeItem = props.activeItem,
        rest = (0, _objectWithoutProperties2["default"])(props, ["items", "onClick", "activeItem"]);
    return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
      className: classes.Root
    }, rest), items.map(function (item, index) {
      return /*#__PURE__*/React.createElement(Item, {
        key: item.id,
        item: item,
        index: index,
        onClick: onClick,
        active: activeItem === item.id
      });
    }));
  } else {
    var children = props.children,
        _rest = (0, _objectWithoutProperties2["default"])(props, ["children"]);

    return /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
      className: classes.Root
    }, _rest), children);
  }
};

VerticalMenu.Item = Item;
var _default = VerticalMenu;
exports["default"] = _default;
//# sourceMappingURL=VerticalMenu.view.js.map